<template>
  <v-container v-if="gear">
    <v-layout row wrap>
      <v-flex lg12 md12 sm12 xs12 :class="['pa-2']">
        <static-page-content slug="gear" />
      </v-flex>
    </v-layout>
    <gear-category :gear="gear.guitars" :title="$lang.guitars" />
    <gear-category :gear="gear.amps" :title="$lang.amps" />
    <gear-category :gear="gear.fx" :title="$lang.fx" />
    <gear-category :gear="gear.recorders" :title="$lang.recorders" />
    <gear-category :gear="gear.misc" :title="$lang.misc" />
    <v-layout row wrap>
      <featured-video />
    </v-layout>
    <news-ticker />
  </v-container>
</template>
<script>
import GearCategory from '../components/gear-category'
import methods from '../mixins/methods'

export default {
  name: 'PageGear',
  components: {
    GearCategory
  },
  mixins: [
    methods
  ],
  data () {
    return {
      gear: null
    }
  },
  mounted () {
    this.getGear()
  },
  methods: {
    setGear (data) {
      const gear = {}
      Object.keys(data).forEach(item => {
        const category = data[item].category
        if (!gear[category]) {
          gear[category] = []
        }
        if (data[item].render) {
          data[item].slug = item
          gear[category].push(data[item])
        }
      })
      this.gear = gear
    },
    getGear () {
      const slug = this.$route.path
      const cachedData = this.retrieveCachedData('gear', slug)
      if (cachedData) {
        return this.setGear(cachedData)
      }
      this.$http({
        url: this.getRoute('gear').url
      }).then(response => {
        const data = response.data.data
        this.setGear(data)
        this.cacheData(slug, 'gear', data)
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/gear.vue